import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';


@Component({
  selector: 'app-form-purchase-order',
  template: `
    <form [formGroup]="purchaseOrderForm" (ngSubmit)="onSubmit()">
      <div class="form-group">
        <label for="settlement">Settlement</label>
        <select id="settlement" formControlName="settlement_id" class="form-control">
          <option [ngValue]="null">Select Settlement</option>
          <!-- Add settlement options here -->
        </select>
      </div>

      <div class="form-group">
        <label for="tanque">Tank</label>
        <select id="tanque" formControlName="tanque_id" class="form-control">
          <option [ngValue]="null">Select Tank</option>
          <!-- Add tank options here -->
        </select>
      </div>

      <div class="form-group">
        <label for="supplier">Supplier</label>
        <select id="supplier" formControlName="supplier_id" class="form-control">
          <option [ngValue]="null">Select Supplier</option>
          <!-- Add supplier options here -->
        </select>
      </div>

      <div class="form-group">
        <label for="notes">Notes</label>
        <textarea id="notes" formControlName="notes" class="form-control"></textarea>
      </div>

      <div formArrayName="purchase_order_items_attributes">
        <h3>Items</h3>
        <button type="button" (click)="addItem()" class="btn btn-secondary mb-3">
          Add Item
        </button>

        <div *ngFor="let item of items.controls; let i=index" [formGroupName]="i" class="card mb-3 p-3">
          <div class="row">
            <div class="col">
              <label>Supplier Item</label>
              <select formControlName="supplier_item_id" class="form-control">
                <option [ngValue]="null">Select Item</option>
                <!-- Add supplier items here -->
              </select>
            </div>
            <div class="col">
              <label>Stock</label>
              <select formControlName="stock_id" class="form-control">
                <option [ngValue]="null">Select Stock</option>
                <!-- Add stock options here -->
              </select>
            </div>
            <div class="col">
              <label>Quantity</label>
              <input type="number" formControlName="quantity" class="form-control">
            </div>
            <div class="col">
              <label>Unit Price</label>
              <input type="number" formControlName="unit_price" class="form-control" step="0.01">
            </div>
            <div class="col-auto d-flex align-items-end">
              <button type="button" (click)="removeItem(i)" class="btn btn-danger mb-3">
                Remove
              </button>
            </div>
          </div>
        </div>
      </div>

      <button type="submit" class="btn btn-primary" [disabled]="!purchaseOrderForm.valid">
        Submit
      </button>
    </form>
  `,
  styleUrls: []
})
export class FormPurchaseOrderComponent {
  purchaseOrderForm: FormGroup = new FormGroup({});

  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.purchaseOrderForm = this.fb.group({
      settlement_id: [null, Validators.required],
      tanque_id: [null, Validators.required],
      supplier_id: [null, Validators.required],
      notes: [''],
      purchase_order_items_attributes: this.fb.array([])
    });
  }

  get items() {
    return this.purchaseOrderForm.get('purchase_order_items_attributes') as FormArray;
  }

  addItem() {
    const itemForm = this.fb.group({
      supplier_item_id: [null, Validators.required],
      stock_id: [null, Validators.required],
      quantity: [null, [Validators.required, Validators.min(1)]],
      unit_price: [null, [Validators.required, Validators.min(0.01)]]
    });

    this.items.push(itemForm);
  }

  removeItem(index: number) {
    this.items.removeAt(index);
  }

  onSubmit() {
    if (this.purchaseOrderForm.valid) {
      const formData = {
        purchase_order: this.purchaseOrderForm.value
      };
      console.log(formData);
      // Add your API call here
    }
  }
}
